import { injectable } from 'inversify-props';
import BaseService from '../base-service';

interface IFilterParams {
  usuario: string;
  campo: string;
  classe: string;
}

type UserInfo = any;
type FilterData = any;

@injectable()
export default class UserFiltersService extends BaseService {
  private readonly baseUrl = `${this.getApiPath()}/crm/filtros`;

  public async saveFilters(filters: FilterData, userInfo: UserInfo): Promise<void> {
    const url = `${this.baseUrl}/salvar-filtros`;
    await this.executeRequest(url, { filters, user: userInfo }, 'saving');
  }

  public async deleteFilters(filters: FilterData, userInfo: UserInfo): Promise<void> {
    const url = `${this.baseUrl}/excluir-filtros`;
    await this.executeRequest(url, { filters, user: userInfo }, 'deleting');
  }

  public async getFilters(filters: IFilterParams): Promise<any> {
    const url = `${this.baseUrl}/buscar-filtros`;
    return this.executeRequest(url, filters, 'fetching saved');
  }

  private async executeRequest(url: string, payload: any, operation: string): Promise<any> {
    try {
      return await this.httpService.post(Object, url, payload);
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Error ${operation} filters: ${error.message}`);
      } else {
        throw new Error(`Error ${operation} filters: An unknown error occurred.`);
      }
    }
  }
}
